module.exports = __webpack_public_path__ + "img/img.e03b2e41.svg";